import { Injectable } from '@angular/core';
import { ModalRef, ModalService } from '@spartacus/storefront';
import { Size } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CustomModalService extends ModalService {
  get getModalWindowRefInstance(): any {
    return this.getActiveModal()?.['_windowCmptRef'].instance;
  }

  /** Получить размер активной модалки */
  getActiveModalSize(): Size {
    return this.getModalWindowRefInstance?.size;
  }

  /** Изменить размер активной модалки */
  resizeActiveModal(size: Size): void {
    if (this.getModalWindowRefInstance) {
      this.getModalWindowRefInstance.size = size;
    }
  }

  closeAllActiveModals(reason?: any): void {
    this['modals'].forEach((modal: ModalRef) => {
      modal.close(reason);
    });
  }
}
